// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y_dIlCnXnBvsFt {
  flex: 0 0 36px;
}
.Y_dIlCnXnBvsFt.wP3sOH08qtfUKm {
  flex: 0 0 auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardSwitcherButton": `Y_dIlCnXnBvsFt`,
	"withLabel": `wP3sOH08qtfUKm`
};
export default ___CSS_LOADER_EXPORT___;
